import { Button, Drawer, Grid, Typography } from "@mui/material"
import React from "react"
import { useForm } from "react-hook-form"
import { WSIcons } from "../../../commonFunctions/iIcons";
import WSTextField from "../../../Components/TextBox/WSTextBox";
import WSSelectField from "../../../Components/Select/WSSelect";
import WSPhone from "../../../Components/Phone/WSPhone";

export const GuestSearchDrawer:React.FC<any>=React.memo(({open,onClose})=>{
    const {
        register,
        control,
        handleSubmit
    }= useForm();
    return(
<Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: '20rem', padding: '1rem', top: '5rem', height: `calc(100% - 5rem)` }, // Adjust width and padding to match your design
      }}
    >
      <Grid container direction="column" spacing={2}>
        {/* Header with Close Button */}
        <Grid item container justifyContent="space-between" alignItems="center">
          <Typography variant="h6" fontWeight="bold" color={"green"}>
           Search
          </Typography>
          <WSIcons.CloseIcon onClick={onClose}  />
        </Grid>
        </Grid>
        <Grid item container spacing={2} alignItems="center" sx={{mt:2}}>
         
          <Grid item xs={12}>
          <WSTextField
            label={"Guest Code"}
            {...register("Guestcode")}
            id="Guestcode"
            name="Guestcode"
            control={control}
            rules={{ required: false }}
            labelType="Normal"/>
          </Grid>
          <Grid item xs={12}>
          <WSPhone label={"Phone No"} id={"phoneno"} name={"phoneno"} control={control} labelType="Normal"/>
          </Grid>
          <Grid item xs={12}>
          <WSTextField
            label={"Guest Name"}
            {...register("Guestname")}
            id="Guestname"
            name="Guestname"
            control={control}
            rules={{ required: false }}
            labelType="Normal"/>
          </Grid>
          <Grid item xs={12}>
          <WSTextField
            label={"City"}
            {...register("city")}
            id="city"
            name="city"
            control={control}
            rules={{ required: false }}
            labelType="Normal"/>
          </Grid>
          <Grid item xs={12}>
          <WSTextField
            label={"Zip"}
            {...register("zip")}
            id="zip"
            name="zip"
            control={control}
            rules={{ required: false }}
            labelType="Normal"/>
          </Grid>
          <Grid item container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
          <Grid item>
            <Button variant="outlined" sx={{color:"green",borderColor:"green"}}>
<WSIcons.SyncIcon/>
            </Button>
          </Grid>
          <Grid item>
            <Button variant="contained" color="success">
              Search
            </Button>
          </Grid>
        </Grid>
        </Grid>
        </Drawer>
    )
})